import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, Col, Container, Row} from 'react-bootstrap'
import { useLocation } from 'react-router-dom';

import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger, Flip } from "gsap/all";
import LandingHero from '../UI/Hero/LandingHero';

import postsData from '../data/posts.json';
import {Post} from '../types/post';
import LandingPostsSlider from '../UI/Carousel/LandingPostsSlider';
import StripeGradient from '../UI/Hero/StripeGradient/StripeGradient';
import MeshGradientwhatamesh from '../UI/Hero/StripeGradient/MeshGradientwhatamesh';
import { bloggerPostList } from '../types/bloggerServices';
import { getPosts } from '../services/blogger';



gsap.registerPlugin(ScrollTrigger, Flip, useGSAP);


export default function LandingPageTemplate() {

  const issue_cover='https://fatteh-media-files.s3.amazonaws.com/pages/magazine/cover1.webp';
  
  //const posts: Post[] = postsData as Post[];
  const [posts, setPosts] = useState<bloggerPostList[]>();
  const getData = async () => {
    try{
      const response = await getPosts();
      console.log(response.items);
      setPosts(response.items)
    }
    catch(e){
      console.log(e);
    }
  }

  useEffect(() => {
    getData()
  }, []);


  return (
    <div className='route-container-fullpage' >
        <Row style={{marginRight: '0', marginLeft:'0'}}>
          <MeshGradientwhatamesh />
        </Row>
        {/** <LandingHero issue_num={issue} issue_cover={cover_image}/> */}
        <Container>
          
        { posts && <LandingPostsSlider posts={posts}/> }
        </Container>

        {/**
         * <Row className='about-section'>
           <Col xs={12} sm={7} md={6} className='about-section-text'>
              <div><p>Fatteh is a bold new magazine that aims to inform, inspire and empower LGBTQ+ Ethiopians and the global
              Habesha diaspora.</p>
              <p>We cover the issues that matter to this unique community, allowing its members to see
              themselves fully reflected and authentically represented in a range of Amharic and English language content.</p></div>
              <h2>This is who we are!</h2>
           </Col>
           <Col xs={12} sm={5} md={6} className='about-section-image-wrapper'>
            <div className='about-section-image' >
              <img src={issue_cover} alt='magazine cover image' />
            </div>
           </Col>
        </Row>
         */}

        
    </div>
  );
}
